import settingMutations from "./setting.mutation";
import settingStates from "./setting.state";
import settingActions from "./setting.action";
import settingGetters from "./setting.getters";

export default {
  mutations: settingMutations,
  state: settingStates,
  actions: settingActions,
  getters: settingGetters
};
